import { useState, useMemo, forwardRef } from 'react'

import { Box, Button, Icon, Text } from '@fairfashion/design-system'
import { useTheme } from 'styled-components'

import { MapCard } from '../MapCard/map-card.comp'
import { MapMarkerProps } from '../MapCard/map-card.types'
import { ProvidersTreeModal } from '../ProvidersTreeModal/providers-tree-modal.comp'

import { ProviderMapProps } from './provider-map.types'
import * as Styles from './providers-map.styles'

export const ProviderMap = forwardRef(({ company }: ProviderMapProps) => {
  const [openTreeModal, setOpenTreeModal] = useState<boolean>(false)

  const theme = useTheme()

  const HeaderMap = () => {
    return (
      <Styles.ProvidersMapContainer direction="column" gap={1} id="map">
        <Box
          width="100%"
          justifyContent="space-between"
          flexWrap="wrap"
          gap={3}
        >
          <Box gap={1} direction="column" flex={1}>
            <Text>Mapa do desmatamento</Text>
            <Text color="grey_3" size="small">
              O mapa de desmatamento indica a localização áreas de riscos
              socioambientais.
            </Text>
          </Box>
          <Box>
            <Button
              fontSize={theme.typography.body_size.small}
              variant="outlined"
              padding="10px 14px"
              onClick={() => setOpenTreeModal(true)}
            >
              <Icon name="node_tree" size={16} color="grey_1" />
              Árvore de Relacionamento
            </Button>
          </Box>
        </Box>
      </Styles.ProvidersMapContainer>
    )
  }

  const locations: MapMarkerProps[] = useMemo(() => {
    return [
      {
        lat: company.address?.geoCoords?.coords?.lat ?? 0,
        lng: company.address?.geoCoords?.coords?.lng ?? 0,
      },
    ]
  }, [company])

  return (
    <Box width="100%" position="relative">
      <MapCard
        center={{
          lat: company.address?.geoCoords?.coords?.lat ?? 0,
          lng: company.address?.geoCoords?.coords?.lng ?? 0,
        }}
        locations={locations}
        header={<HeaderMap />}
        maxHeight={'450px'}
        mapOptions={{
          zoom: 13,
        }}
      />
      <ProvidersTreeModal
        open={openTreeModal}
        onClose={() => setOpenTreeModal(false)}
        rootId={company.id}
      />
    </Box>
  )
})
